import { render, staticRenderFns } from "./LxLoadingAnimation.vue?vue&type=template&id=55a885f5&scoped=true"
import script from "./LxLoadingAnimation.vue?vue&type=script&lang=js"
export * from "./LxLoadingAnimation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a885f5",
  null
  
)

export default component.exports